import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-4xl font-bold tracking-tight">CLC Education LMS</h1>
      <p className="text-muted-foreground">
        Learning Management System — scaffold ready, Phase 02 coming.
      </p>
      <a
        href="/api/healthz"
        className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:bg-primary/90"
        target="_blank"
        rel="noreferrer"
      >
        API Health Check
      </a>
    </main>
  );
}
